import { t } from 'i18next';
import { FC } from 'react';
import { useDiscoverDescV2 } from '../shared/use-discover-desc';
import { useDiscoverTitle } from '../shared/use-discover-title';

export const TDK: FC = () => {
  const discoverTitle = useDiscoverTitle();
  const discoverDescriptionV2 = useDiscoverDescV2();
  const discoverKeyword = t('keyword_default');

  return (
    <>
      <title>{discoverTitle}</title>
      <meta name="keywords" content={discoverKeyword} />
      <meta name="description" content={discoverDescriptionV2} />
    </>
  );
};
